import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import theme from '../../../styles/theme';
import moment from "moment";
import { sampleData } from "../SampleData";
import { useGetProjectSchedule } from '../../../interfaces/dashboard';
import AlertMark from '../AlertMark';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProjectStatusLabel from '../../common/ProjectStatusLabel';

const TitleLine = styled.ul`
    list-style-type: none;
    padding:0;
    padding: 0 0.4rem;
    margin:0;
    li {
        // line-height: 2rem;
        font-size: 1.4rem;
        height: 2.5rem;
        display: grid;
        grid-template-columns: minmax(1rem,auto) 12rem 4rem 4rem 8rem 5rem 5rem 10rem 5rem 10rem 10rem 6rem;
        gap:0;
        div {
            margin: 3px 0;
            text-align: center;
        }
        div:nth-child(1){
            text-align: left;
            padding-left: 8px;
        }
        div:nth-child(2), div:nth-child(3){
            text-align: center;
        }
    }
    li:first-child {
        div {
            display: block;
            text-align: center;
        }
        border-bottom:1px solid ${theme.color.black[20]};
    }
`; 
const DescArea = styled.ul`
    list-style-type: none;
    padding: 0 0.4rem 0;
    margin:0;
    li {
        position: relative;
        margin: 0;
        line-height: 2rem;
        font-size: 1.2rem;
        height: 3.25rem;
        display: grid;
        border-radius: 12px;
        grid-template-columns: minmax(1rem,auto) 12rem 4rem 4rem 8rem 5rem 5rem 10rem 5rem 10rem 10rem 6rem;
        gap:0;
        div {
            position: relative;
            text-align: center;
        }
        .title_line {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
            
        }
        .titleEl {
            // width: 40%;
            // display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .align {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        div:nth-child(n+6){
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                border-radius: 12px;
                padding: 2px 8px;
                // width: 70%;
            }
        }
    }
    li:first-child {
        margin-top: 0.5rem;
    }
    li:nth-child(even){
        background: rgba(0, 0, 0, 0.04);
    }
`;
const BarBox = styled.div`
    // margin: 0px 10px;
    padding:0;
    width: 90%;
    height: 2rem;
    border: 1px solid red;
    border-radius: 12px;
    display: flex;
    justify-content: flex-start;
`;

const BarStyle = styled.div`
    margin:0;padding:0;
    width: calc(5% + ${(props)=>props.size ? props.size : '0'}%);
    min-width: 5%;
    max-width: 100%;
    // height: 2rem;
    background: rgb(${(props)=>props.size ? 260-(props.size/20) : '255'}, ${(props)=>props.size ? 133+props.size : '0'}, ${(props)=>props.size ? 153+props.size : '0'});
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 10px;
    border: 0;
    span {
        display: inline-block;
        margin:0;
        padding-left: 8px;
        font-size: 0.9rem;
        white-space: nowrap;
    }
    transition: all 1000ms ease-in-out, transform 1000ms ease-in-out;
`;
const EmgMark = styled.div`
    position: absolute !important;
    top: -0.5rem;
    left: -0.5rem;
    width: 2.2rem !important;
    height: 1.2rem !important;
    font-size: 0.8rem !important;
    color: ${theme.color.white[100]};
    background: ${theme.color.secondary.red};
    border-radius: 12px;
    z-index:10;
`;

const ScheduleList = () => {

    // const [dateArray, setDateArray] = useState();
    const [list, setList] = useState(sampleData);
    const {data} = useGetProjectSchedule();

    const setting = {
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows:false,
        vertical: true,
    }
    // useEffect(()=>{
    //     if(data){
    //         const temp = data.map((item,index)=>{
    //             const temp = item.inst_nm_list !== null ? item.inst_nm_list.replaceAll(',','') : '';
    //             const spTemp = (temp !== '' ? [...new Set(item.inst_nm_list.split(','))] : [])
    //             const spTempFilter = spTemp.filter((item)=>item!=='')
    //             // console.log(spTempFilter)

    //             return {
    //                 ...item,
    //                 set_person: spTempFilter
    //             }
    //         })
    //         setList(temp);
    //     }
    // },[data])

    return (
        <React.Fragment>
            <TitleLine>
                <li>
                    <div style={{textAlign:'left'}}>과업명</div>
                    <div>발주처</div>
                    <div>지점수</div>
                    <div>카메라</div>
                    <div>설치자</div>
                    {/* <div>문의/견적</div> */}
                    <div>촬영시간</div>
                    <div>설치일</div>
                    <div>촬영기간</div>
                    <div>철거일</div>
                    <div>코딩</div>
                    <div>코딩진행상황</div>
                    <div>완료/납품</div>
                </li>
            </TitleLine>
            <Slider {...setting}>
            <DescArea>
                {list && list.map((item,index)=>
                    {
                        let targetColor = theme.color.white[100];
                        switch(item.pro_st){
                            case 'Q':
                            case 'R':
                                targetColor = theme.color.request;
                                break;
                            case 'I':
                                targetColor = theme.color.setting;
                                break;
                            case 'S':
                                targetColor = theme.color.coding;
                                break;
                            case 'E':
                                targetColor = theme.color.complete;
                                break;
                        }
                        return (
                            <li key={index} style={{border:item.alert===true?'1px solid red':'0'}}>
                                <div className="title_line">&nbsp;
                                    <ProjectStatusLabel status={item.pro_st} value={item.pro_st_nm}/>
                                    <div className="titleEl">{item.title}</div>
                                </div>
                                <div className="title_line">
                                    <div className="titleEl">{item.cname}</div>
                                </div>
                                <div className="align">{item.point_cnt}</div>
                                <div className="align">{item.camera_cnt}</div>
                                <div className="align">
                                    {item.set_person && item.set_person.map((item,index)=> index>0? ','+item : item)}
                                </div>
                                <div><span style={{background: theme.color.setting}}>{item.rec_timeH && parseInt(item.rec_timeH,10)}H</span></div>
                                {/* <div><span style={{background: theme.color.request}}>{moment(item.req_from).format('MM/DD')}</span></div> */}
                                <div><span style={{background: theme.color.setting}}>{item.set_from && moment(item.set_from).format('MM/DD')}</span><AlertMark to={item.set_from} right={'-0.5rem'} /></div>
                                <div><span style={{background: theme.color.coding}}>{item.rec_from && moment(item.rec_from).format('MM/DD')} - {item.rec_to && moment(item.rec_to).format('MM/DD')}</span><AlertMark /></div>
                                <div><span style={{background: theme.color.setting}}>{item.set_to && moment(item.set_to).format('MM/DD')}</span><AlertMark to={item.set_to} right={'-0.5rem'} /></div>
                                <div><span style={{background: theme.color.coding}}>{item.coding_from && moment(item.coding_from).format('MM/DD')} - {item.coding_to && moment(item.coding_to).format('MM/DD')}</span><AlertMark to={item.coding_to} /></div>
                                <div>
                                    { (item.coding_progress && item.coding_progress > 0) &&
                                    <BarBox>
                                        <BarStyle size={item.coding_progress}>
                                            <span>{item.coding_progress}%</span>
                                        </BarStyle>
                                    </BarBox>
                                    }
                                </div>
                                <div><span style={{background: theme.color.complete}}>{item.odate && moment(item.odate).format('MM/DD')}</span></div>
                                {(item.alert===true) && <EmgMark>긴급</EmgMark>}
                            </li>
                        )
                    }
                )}
            </DescArea>
            <DescArea>
                {list && list.map((item,index)=>
                    {
                        let targetColor = theme.color.white[100];
                        switch(item.pro_st){
                            case 'Q':
                            case 'R':
                                targetColor = theme.color.request;
                                break;
                            case 'I':
                                targetColor = theme.color.setting;
                                break;
                            case 'S':
                                targetColor = theme.color.coding;
                                break;
                            case 'E':
                                targetColor = theme.color.complete;
                                break;
                        }
                        return (
                            <li key={index} style={{border:item.alert===true?'1px solid red':'0'}}>
                                <div className="title_line">&nbsp;
                                    <ProjectStatusLabel status={item.pro_st} value={item.pro_st_nm}/>
                                    <div className="titleEl">{item.title}</div>
                                </div>
                                <div className="title_line">
                                    <div className="titleEl">{item.cname}</div>
                                </div>
                                <div className="align">{item.point_cnt}</div>
                                <div className="align">{item.camera_cnt}</div>
                                <div className="align">
                                    {item.set_person && item.set_person.map((item,index)=> index>0? ','+item : item)}
                                </div>
                                <div><span style={{background: theme.color.setting}}>{item.rec_timeH && parseInt(item.rec_timeH,10)}H</span></div>
                                {/* <div><span style={{background: theme.color.request}}>{moment(item.req_from).format('MM/DD')}</span></div> */}
                                <div><span style={{background: theme.color.setting}}>{item.set_from && moment(item.set_from).format('MM/DD')}</span><AlertMark to={item.set_from} right={'-0.5rem'} /></div>
                                <div><span style={{background: theme.color.coding}}>{item.rec_from && moment(item.rec_from).format('MM/DD')} - {item.rec_to && moment(item.rec_to).format('MM/DD')}</span><AlertMark /></div>
                                <div><span style={{background: theme.color.setting}}>{item.set_to && moment(item.set_to).format('MM/DD')}</span><AlertMark to={item.set_to} right={'-0.5rem'} /></div>
                                <div><span style={{background: theme.color.coding}}>{item.coding_from && moment(item.coding_from).format('MM/DD')} - {item.coding_to && moment(item.coding_to).format('MM/DD')}</span><AlertMark to={item.coding_to} /></div>
                                <div>
                                    { (item.coding_progress && item.coding_progress > 0) &&
                                    <BarBox>
                                        <BarStyle size={item.coding_progress}>
                                            <span>{item.coding_progress}%</span>
                                        </BarStyle>
                                    </BarBox>
                                    }
                                </div>
                                <div><span style={{background: theme.color.complete}}>{item.odate && moment(item.odate).format('MM/DD')}</span></div>
                                {(item.alert===true) && <EmgMark>긴급</EmgMark>}
                            </li>
                        )
                    }
                )}
            </DescArea>
            </Slider>
        </React.Fragment>
    )
}

export default ScheduleList;